"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insetPropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const sides = ['all', 'x', 'y', 'top', 'bottom', 'left', 'right'];
const clipValues = ['border-box', 'padding-box'];
const paddingValues = ['current', '0'];
const insetPropDefs = {
    asChild: index_js_1.asChildProp,
    side: {
        type: 'enum',
        className: 'rt-r-side',
        values: sides,
        default: 'all',
        responsive: true,
    },
    clip: {
        type: 'enum',
        className: 'rt-r-clip',
        values: clipValues,
        default: 'border-box',
        responsive: true,
    },
    p: {
        type: 'enum',
        className: 'rt-r-p',
        values: paddingValues,
        parseValue: parsePaddingValue,
        default: undefined,
        responsive: true,
    },
    px: {
        type: 'enum',
        className: 'rt-r-px',
        values: paddingValues,
        parseValue: parsePaddingValue,
        default: undefined,
        responsive: true,
    },
    py: {
        type: 'enum',
        className: 'rt-r-py',
        values: paddingValues,
        parseValue: parsePaddingValue,
        default: undefined,
        responsive: true,
    },
    pt: {
        type: 'enum',
        className: 'rt-r-pt',
        values: paddingValues,
        parseValue: parsePaddingValue,
        default: undefined,
        responsive: true,
    },
    pr: {
        type: 'enum',
        className: 'rt-r-pr',
        values: paddingValues,
        parseValue: parsePaddingValue,
        default: undefined,
        responsive: true,
    },
    pb: {
        type: 'enum',
        className: 'rt-r-pb',
        values: paddingValues,
        parseValue: parsePaddingValue,
        default: undefined,
        responsive: true,
    },
    pl: {
        type: 'enum',
        className: 'rt-r-pl',
        values: paddingValues,
        parseValue: parsePaddingValue,
        default: undefined,
        responsive: true,
    },
};
exports.insetPropDefs = insetPropDefs;
function parsePaddingValue(value) {
    return value === 'current' ? 'inset' : value;
}
//# sourceMappingURL=inset.props.js.map